import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=6d4a9512&scoped=true"
import script from "./ConfirmButton.vue?vue&type=script&lang=js"
export * from "./ConfirmButton.vue?vue&type=script&lang=js"
import style0 from "./ConfirmButton.vue?vue&type=style&index=0&id=6d4a9512&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a9512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4a9512')) {
      api.createRecord('6d4a9512', component.options)
    } else {
      api.reload('6d4a9512', component.options)
    }
    module.hot.accept("./ConfirmButton.vue?vue&type=template&id=6d4a9512&scoped=true", function () {
      api.rerender('6d4a9512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ConfirmButton.vue"
export default component.exports